import { all, call, put, takeLatest } from 'redux-saga/effects';
import { AxiosPost } from '../../../utils/axios';
import { getFbTrackingPayload } from '../../../utils/fbTracking';
import * as actions from './actions';

function* createPendingSinastria(action) {
  try {
    const result = yield call(AxiosPost, `/sinastria/create_pending_synastry/`, action.payload);
    yield put(actions.createPendingSinastriaSuccess(result.data.reading_id));
  } catch (e) {
    yield put(actions.createPendingSinastriaFailure(e));
  }
}

function* sinastriaCheckout(action) {
  try {
    const result = yield call(AxiosPost, `/sinastria/create_checkout/`, { ...action.payload, ...getFbTrackingPayload() });
    yield put(actions.sinastriaCheckoutSuccess());
    window.location.href = result.data.checkout_url;
  } catch (e) {
    yield put(actions.sinastriaCheckoutFailure(e));
  }
}

function* sinastriaPaypalOrder(action) {
  try {
    const result = yield call(AxiosPost, `/sinastria/create_paypal_order/`, { ...action.payload, ...getFbTrackingPayload() });
    yield put(actions.sinastriaPaypalOrderSuccess());
    window.location.href = result.data.approve_url;
  } catch (e) {
    yield put(actions.sinastriaPaypalOrderFailure(e));
  }
}

function* sinastriaVerify(action) {
  try {
    const result = yield call(AxiosPost, `/sinastria/verify_purchase/`, action.payload);
    // Un pago aún pendiente (p. ej. voucher OXXO sin pagar) responde 202 sin
    // `verified`; axios lo resuelve como éxito, así que hay que filtrarlo.
    if (result.data?.verified) {
      yield put(actions.sinastriaVerifyPurchaseSuccess(result.data));
    } else {
      yield put(actions.sinastriaVerifyPurchaseFailure(result.data));
    }
  } catch (e) {
    yield put(actions.sinastriaVerifyPurchaseFailure(e));
  }
}

function* sinastriaVerifyPaypal(action) {
  try {
    const result = yield call(AxiosPost, `/sinastria/verify_paypal_purchase/`, { ...action.payload, ...getFbTrackingPayload() });
    if (result.data?.verified) {
      yield put(actions.sinastriaVerifyPaypalSuccess(result.data));
    } else {
      yield put(actions.sinastriaVerifyPaypalFailure(result.data));
    }
  } catch (e) {
    yield put(actions.sinastriaVerifyPaypalFailure(e));
  }
}

export default function* sinastriaSaga() {
  yield all([
    takeLatest(actions.CREATE_PENDING_SINASTRIA_REQUEST, createPendingSinastria),
    takeLatest(actions.SINASTRIA_CHECKOUT_REQUEST, sinastriaCheckout),
    takeLatest(actions.SINASTRIA_PAYPAL_REQUEST, sinastriaPaypalOrder),
    takeLatest(actions.SINASTRIA_VERIFY_REQUEST, sinastriaVerify),
    takeLatest(actions.SINASTRIA_VERIFY_PAYPAL_REQUEST, sinastriaVerifyPaypal),
  ]);
}
